import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Inject Authorization header from localStorage token if available (JWT path)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pmp_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function setToken(token) {
  if (token) localStorage.setItem("pmp_token", token);
  else localStorage.removeItem("pmp_token");
}

export function getToken() {
  return localStorage.getItem("pmp_token");
}
